import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React from "react";
import firebase from "firebase/app";
import { connect } from "react-redux";
import classNames from "classnames";
import { Switch, Route, Redirect } from "react-router-dom";
import { push } from "connected-react-router";
import SecurityModal from "./SecurityModal/SecurityModal";
import Countdown from "react-countdown";
import AccessAlarmIcon from "@material-ui/icons/AccessAlarm";
import ExitToApp from "@material-ui/icons/ExitToApp";
import { Done as SuccessIcon } from "@material-ui/icons";
import { AppBar, Toolbar, Typography, Button, IconButton } from "@material-ui/core";
import { Row, Col, Modal, ModalBody, ModalFooter, Spinner } from "reactstrap";
import MenuIcon from "@material-ui/icons/Menu";
import { styles } from "./styles";
import Drawer from "./components/Drawer";
import withStyles from "@material-ui/core/styles/withStyles";
import { selectUserProfile } from "../../Router/selectors";
import { selectRoutes, selectMenuItems, selectReplacedReducers, areUsersLoaded, areJobpacksLoaded, areGroupsLoaded, requestingJobs, requestingUsers } from "./selectors";
import { setClientConfig as _setClientConfig, logout as _logout, replaceReducers as _replaceReducers, getConfig, getUsers, getJobPacks, getGroups } from "./actions";

var Main = /*#__PURE__*/function (_React$Component) {
  _inherits(Main, _React$Component);

  var _super = _createSuper(Main);

  function Main(props) {
    var _this;

    _classCallCheck(this, Main);

    _this = _super.call(this, props);

    _this.clearTimeoutFunc = function () {
      if (_this.warnTimeout) clearTimeout(_this.warnTimeout);
      if (_this.logoutTimeout) clearTimeout(_this.logoutTimeout);
    };

    _this.setTimeout = function () {
      _this.warnTimeout = setTimeout(_this.warn, _this.state.warningTime);
      _this.logoutTimeout = setTimeout(_this.logout, _this.state.signoutTime);
    };

    _this.resetTimeout = function () {
      _this.clearTimeoutFunc();

      _this.setTimeout();
    };

    _this.warn = function () {
      _this.setState({
        warningModal: true
      });
    };

    _this.logout = function () {
      _this.destroy();
    };

    _this.destroy = function () {
      //clear the session
      firebase.auth().signOut();
      push("/login");
      window.location.assign("/");
    };

    _this.handleDrawerOpen = function () {
      _this.setState({
        open: true
      });
    };

    _this.handleDrawerClose = function () {
      _this.setState({
        open: false
      });
    };

    _this.handleMenu = function (event) {
      _this.setState({
        anchorEl: event.currentTarget
      });
    };

    _this.handleClose = function () {
      _this.setState({
        anchorEl: null
      });
    };

    props.setClientConfig(props.profileConfig, props.pagesConfig, props.reportsConfig, props.firebaseConfig);
    _this.state = {
      open: true,
      anchorEl: null,
      warningTime: 1000 * 60 * 178,
      signoutTime: 1000 * 60 * 180,
      warningModal: false
    };
    props.getConfig();
    props.getProfile();
    props.getUsers();
    props.getJobPacks();
    props.getGroups();
    return _this;
  }

  _createClass(Main, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.events = ["load", "mousemove", "mousedown", "click", "scroll", "keypress"];

      for (var i in this.events) {
        window.addEventListener(this.events[i], this.resetTimeout);
      }

      this.setTimeout();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.routes !== prevProps.routes && prevProps.routes === false) {
        this.props.replaceReducers(this.props.routes, this.props.replaceReducer, this.props.history);
      }

      if (this.props.location.pathname !== prevProps.location.pathname) {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var classes = this.props.classes;
      var shouldRedirect = this.props.match.url === this.props.location.pathname;

      var renderer = function renderer(_ref) {
        var minutes = _ref.minutes,
            seconds = _ref.seconds;
        return /*#__PURE__*/React.createElement("span", null, minutes, ":", seconds);
      };

      return /*#__PURE__*/React.createElement("div", {
        className: classes.root
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.props.jobsLoaded === false || this.props.usersLoaded === false || this.props.groupsLoaded === false,
        style: {
          maxWidth: "400px"
        }
      }, /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: "center",
          padding: "24px"
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        style: {
          height: 100,
          width: 100,
          background: "white",
          margin: "0 auto",
          display: "block"
        },
        color: "primary"
      }), /*#__PURE__*/React.createElement(Typography, {
        align: "center",
        style: {
          textAlign: "center",
          marginTop: 15,
          color: "rgba(0, 0, 0, 0.87)",
          fontWeight: "bolder",
          fontSize: 20
        },
        variant: "body2"
      }, this.props.jobsLoaded && /*#__PURE__*/React.createElement(SuccessIcon, {
        style: {
          color: "green"
        }
      }), " ", "Job Packs", " ", this.props.jobsLoaded ? "Loaded" : "Loading", /*#__PURE__*/React.createElement("br", null), this.props.usersLoaded && /*#__PURE__*/React.createElement(SuccessIcon, {
        style: {
          color: "green"
        }
      }), " ", "Users", " ", this.props.usersLoaded ? "Loaded" : "Loading", /*#__PURE__*/React.createElement("br", null), this.props.usersLoaded && /*#__PURE__*/React.createElement(SuccessIcon, {
        style: {
          color: "green"
        }
      }), " ", "Reports", " ", this.props.usersLoaded ? "Loaded" : "Loading", /*#__PURE__*/React.createElement("br", null), this.props.groupsLoaded && /*#__PURE__*/React.createElement(SuccessIcon, {
        style: {
          color: "green"
        }
      }), " ", "Groups", " ", this.props.groupsLoaded ? "Loaded" : "Loading")))), /*#__PURE__*/React.createElement(AppBar, {
        position: "absolute",
        className: classNames(classes.appBar, this.state.open && classes.appBarShift)
      }, /*#__PURE__*/React.createElement(Toolbar, {
        disableGutters: !this.state.open
      }, /*#__PURE__*/React.createElement(IconButton, {
        color: "inherit",
        "aria-label": "open drawer",
        onClick: this.handleDrawerOpen,
        className: classNames(classes.menuButton, this.state.open && classes.hide)
      }, /*#__PURE__*/React.createElement(MenuIcon, null)), /*#__PURE__*/React.createElement("img", {
        onClick: function onClick() {
          _this2.props.goToRoute("/dashboard");
        },
        alt: "img",
        src: this.props.profileConfig.logo_src,
        style: {
          margin: 8,
          height: 60,
          width: "auto",
          cursor: "pointer"
        }
      }), /*#__PURE__*/React.createElement(Typography, {
        color: "inherit",
        className: classes.flex,
        noWrap: true,
        variant: "h5",
        style: {
          cursor: "pointer"
        },
        onClick: function onClick() {
          _this2.props.goToRoute("/dashboard");
        }
      }, this.props.profileConfig.title), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconButton, {
        className: classes.rightIcon,
        onClick: this.props.logout,
        color: "inherit",
        button: true
      }, /*#__PURE__*/React.createElement(ExitToApp, null))))), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.warningModal
      }, /*#__PURE__*/React.createElement(ModalBody, null, "Are you still there? You will be logged out automatically in 2 minutes if you do not perform any action."), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(AccessAlarmIcon, {
        style: {
          marginLeft: "192px"
        }
      })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Countdown, {
        date: Date.now() + 120000,
        renderer: renderer
      })))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
          _this2.setState({
            warningModal: false
          });
        }
      }, "Keep me Loggedin!"), /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "secondary",
        onClick: function onClick() {
          firebase.auth().signOut();
          push("/login");
        }
      }, "Log me Out!")))), /*#__PURE__*/React.createElement(Drawer, {
        open: this.state.open,
        handleDrawerClose: this.handleDrawerClose,
        menuItems: this.props.menuItems,
        logout: this.props.logout,
        profile: this.props.profile
      }), /*#__PURE__*/React.createElement("main", {
        className: classes.content
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.toolbar2
      }), /*#__PURE__*/React.createElement(Switch, {
        onUpdate: function onUpdate() {
          return window.scrollTo(0, 0);
        }
      }, this.props.routes && this.props.replacedReducers && this.props.routes.map(function (e, i) {
        return /*#__PURE__*/React.createElement(Route, {
          path: e.link,
          component: e.component.view,
          key: "page" + i
        });
      }), this.props.routes && this.props.replacedReducers && /*#__PURE__*/React.createElement(Route, {
        path: "/profile",
        component: this.props.profileConfig.component.view
      }), shouldRedirect && /*#__PURE__*/React.createElement(Redirect, {
        to: "/dashboard"
      }), /*#__PURE__*/React.createElement(Route, {
        path: "*",
        component: SecurityModal
      }))));
    }
  }]);

  return Main;
}(React.Component);

export default connect(function (store, props) {
  return {
    profile: selectUserProfile(store),
    routes: selectRoutes(store),
    menuItems: selectMenuItems(store),
    replacedReducers: selectReplacedReducers(store),
    name: props.profileConfig.name_selector(store),
    usersLoaded: areUsersLoaded(store),
    jobsLoaded: areJobpacksLoaded(store),
    requestingUsers: requestingUsers(store),
    groupsLoaded: areGroupsLoaded(store),
    requestingJobs: requestingJobs(store)
  };
}, function (dispatch, props) {
  return {
    setClientConfig: function setClientConfig(profileConfig, pagesConfig, reportsConfig, firebaseConfig) {
      return dispatch(_setClientConfig(profileConfig, pagesConfig, reportsConfig, firebaseConfig));
    },
    logout: function logout() {
      return dispatch(_logout());
    },
    replaceReducers: function replaceReducers(routes, replaceReducer, history) {
      return dispatch(_replaceReducers(routes, replaceReducer, history));
    },
    getProfile: function getProfile() {
      return dispatch(props.profileConfig.get_profile_action());
    },
    getConfig: getConfig,
    getUsers: getUsers,
    getJobPacks: getJobPacks,
    goToRoute: function goToRoute(route) {
      return dispatch(push(route));
    },
    getGroups: getGroups
  };
})(withStyles(styles)(Main));